import { RC_LOAD_APP, ACCOUNT_FILE, CARRIER, REPORTS_BASE_URL, REPORTS_STATS, REPORTS_BALANCE, REPORTS_MAIN, CALL_RESTRICTION, ROUTING_BASE_URL, ROUTING_URL, REPORTS_ACCOUNT_STATS, REPORTS_CARRIER_STATS, CDR_BILLING, AGENT_SECTION, RATEDECK_BASE_URL, ADD_RATEDECK_URL, LISTING_RATEDECK, ACCOUNT_DASHBOARD, CARRIER_DASHBOARD, ADD_ACCOUNT_INFORMATION, INVOICE_BASE_URL, INVOICE_AGENT_BASE_URL, INVOICE_EMAIL_HISTORY_URL, INVOICE_BASE, CREATE_RATEDECK_URL, ROUTE_BASE_URL, RATEDECK_URL, FIND_ROUTE_URL, SUBJECT_BLOCK, MEDIA_ROUTING_URL, REPORTS_ACCOUNT_REJECTION, REPORTS_TRAFFIC_STATS, REPORTS_CARRIER_MEDIA_STATS } from '../routers/RouteConstants';


export var naver = {
    [RC_LOAD_APP]: {
        "/": {
            "id": "M_HOME",
            "name": "Home",
            "url": RC_LOAD_APP,
            "fa_icon": "fa fa-home"
        },
        "fa_icon": "fa fa-home"
    },
    [ACCOUNT_FILE]: {
        "/": {
            "id": "ACCOUNT_FILE",
            "name": "Accounts",
            "url": ACCOUNT_FILE,
            "fa_icon": "fa fa-user"
        },
        // "/dashboard": {
        //     "id": "ACCOUNT_DASHBOARD",
        //     "name": "Dashboard",
        //     "url": ACCOUNT_DASHBOARD,
        //     "fa_icon": "fa fa-home"
        // },
        // "/add-account-info": {
        //     "id": "ADD_ACCOUNT_INFORMATION",
        //     "name": "Add Information",
        //     "url": ADD_ACCOUNT_INFORMATION,
        //     "fa_icon": "fa fa-home"
        // },
        "fa_icon": "fa fa-user"
    },
    [CARRIER]: {
        "/": {
            "id": "CARRIER",
            "name": "Carriers",
            "url": CARRIER,
            "fa_icon": "icon-drawer3"
        },
        // "/dashboard": {
        //     "id": "CARRIER_DASHBOARD",
        //     "name": "Dashboard",
        //     "url": CARRIER_DASHBOARD,
        //     "fa_icon": "fa fa-home"
        // },
        "fa_icon": "icon-drawer3"
    },
    [CDR_BILLING]: {
        "/": {
            "id": "CDR_BILLING",
            "name": "CDRs Search",
            "url": CDR_BILLING,
            "fa_icon": "fa fa-credit-card"
        }
    },
    [AGENT_SECTION]: {
        "/": {
            "id": "AGENT_SECTION",
            "name": "Agents List",
            "url": AGENT_SECTION,
            "fa_icon": "icon-people"
        }
    },
    [SUBJECT_BLOCK]: {
        "/": {
            "id": "SUBJECT_BLOCK",
            "name": "Global Stir Subject Block",
            "url": SUBJECT_BLOCK,
            "fa_icon": "fa fa-book"
        }
    },
   
    [RATEDECK_BASE_URL]: {
        "/listing": {
            "id": "RATEDECKLISTING",
            "name": "Rate Deck Listing",
            "url": RATEDECK_BASE_URL,
            "fa_icon": "icon-file-zip"
        },
        "fa_icon": "icon-archive"
    },
    [REPORTS_BASE_URL]: {
        // "/": {
        //     "id": "REPORTS_MAIN",
        //     "name": "Report",
        //     "url": REPORTS_MAIN,
        //     "fa_icon": "fa fa-bars"
        // },
        // "/balance": {
        //     "id": "REPORTS_BALANCE",
        //     "name": "Report-balance",
        //     "url": REPORTS_BALANCE,
        //     "fa_icon": "fa fa-plus"
        // },
        "/account-stats": {
            "id": "ACCOUNT_STATS",
            "name": "Account Stats",
            "url": REPORTS_ACCOUNT_STATS,
            "fa_icon": "fa fa-plus"
        },
        "/carrier-stats": {
            "id": "CARRIER_STATS",
            "name": "Carrier Stats",
            "url": REPORTS_CARRIER_STATS,
            "fa_icon": "fa fa-plus"
        },
        "/account-rejection": {
            "id": "ACCOUNT_REJECTION",
            "name": "Account Rejection",
            "url": REPORTS_ACCOUNT_REJECTION,
            "fa_icon": "fa fa-ban"
        },
        "/traffic-stats": {
            "id": "TRAFFIC_STATS",
            "name": "Traffic Stats",
            "url": REPORTS_TRAFFIC_STATS,
            "fa_icon": "fa fa-line-chart"
        },
        "/carrier-media-stats": {
            "id": "CARRIER_MEDIA_STATS",
            "name": "Carrier Media Stats",
            "url": REPORTS_CARRIER_MEDIA_STATS,
            "fa_icon": "fa fa-sitemap"
        },
        "fa_icon": "icon-file-stats "
    },
    [INVOICE_BASE]: {
        "/main": {
            "id": "INVOICE_BASE_URL",
            "name": "Invoice Tab",
            "url": INVOICE_BASE_URL,
            "fa_icon": "icon-file-zip"
        },
        "/agent": {
            "id": "INVOICE_AGENT_BASE_URL",
            "name": "Agent Invoice",
            "url": INVOICE_AGENT_BASE_URL,
            "fa_icon": "icon-file-zip"
        },
        "/email-history": {
            "id": "INVOICE_EMAIL_HISTORY_URL",
            "name": "Email History",
            "url": INVOICE_EMAIL_HISTORY_URL,
            "fa_icon": "icon-envelop"
        },
        "fa_icon": "icon-archive"
    },
    [INVOICE_AGENT_BASE_URL]: {
        "/listing": {
            "id": "INVOICE_AGENT_BASE_URL",
            "name": "Agent Invoice",
            "url": INVOICE_AGENT_BASE_URL,
            "fa_icon": "icon-file-zip"
        },
        "fa_icon": "icon-archive"
    },
    [ROUTE_BASE_URL]: {
        "/create-ratedeck": {
            "id": "CREATE_RATEDECK_BASE",
            "name": "Create Ratedeck",
            "url": CREATE_RATEDECK_URL,
            "fa_icon": "icon-file-zip"
        },
        "/call-restriction": {
            "id": "CALL_RESTRICTION",
            "name": "Global Call Restriction",
            "url": CALL_RESTRICTION,
            "fa_icon": "fas fa-phone-slash"
        },
        "/find-route": {
            "id": "FIND_ROUTE_URL",
            "name": "Find Route",
            "url": FIND_ROUTE_URL,
            "fa_icon": "fas fa-phone-slash"
        },
        "/media-ip-block": {
            "id": "MEDIA_ROUTING_URL",
            "name": "Media IP Block",
            "url": MEDIA_ROUTING_URL,
            "fa_icon": "fas fa-phone-slash"
        },
        "fa_icon": "icon-archive"
    },
   
   

}
